// Selectors that take into account the state in which the user is in the UI (e.g. which subflow they are in).
// Also combine multiple lower level selectors like bundle selectors and seatmap selectors.

import { createSelector, MemoizedSelector } from '@ngrx/store';

import { Category } from '@fcom/dapi/api/models/category';
import { FinnairServiceVariantItemV3 } from '@fcom/dapi/api/models/finnair-service-variant-item-v-3';

import { CommonBookingFeatureState } from '../store.interface';
import {
  seatBundleCatalogServicesByFlightAndPassengerSelector,
  seatBundleCategoriesToSubCategoriesMappingSelector,
} from './bundle.selector';

/**
 * Returns the FinnairServiceVariantItemV3[] that should be offered for a category+flight+passenger.
 * For Category.SEAT_WIFI, comboVariants are matched by the presence of parameters.variantTag instead of subCategory,
 * since wifi variants are distinguished by variantTag rather than subCategory.
 */
export const matchingSeatBundleOfferServicesSelector = (
  category: Category,
  flightId: string,
  passengerId: string
): MemoizedSelector<CommonBookingFeatureState, FinnairServiceVariantItemV3[]> =>
  createSelector(
    seatBundleCatalogServicesByFlightAndPassengerSelector,
    seatBundleCategoriesToSubCategoriesMappingSelector,
    (bundleCatalog, bundleCategoryMapping) => {
      const comboVariants = bundleCatalog[flightId]?.[passengerId] ?? [];
      if (category === Category.SEAT_WIFI) {
        return comboVariants.filter((combo) => combo.parameters?.variantTag != null);
      }
      return comboVariants.filter((combo) => bundleCategoryMapping[category]?.has(combo.subCategory));
    }
  );
